import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const DeliverablesOverviewPage = lazyWithRetry(() => import('./pages/DeliverablesOverviewPage'))
const DeliverablesDetailPage = lazyWithRetry(() => import('./pages/DeliverablesDetailPage'))

const routes: AppRoute[] = [
  {
    path: 'super-admin/deliverables',
    element: DeliverablesOverviewPage,
    meta: {
      title: 'deliverables.overview.title',
      require: { superAdminOnly: true },
    },
  },
  {
    path: 'super-admin/deliverables/:organizationId',
    element: DeliverablesDetailPage,
    meta: {
      title: 'deliverables.overview.title',
      require: { superAdminOnly: true },
    },
  },
]

export default routes
